import React from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'formik';
import Yup from 'yup';

import createForm, { TextField, CheckField } from '../shared/forms';

const resourceName = 'location';

export default createForm({
  resourceName,

  redirectPath: () => 'locations',
  submitPath: () => 'locations',
  updatePath: (props) => `locations/${props.match.params.locationId}`,

  mapPropsToValues: (props) => {
    return props.update || {
      name: '',
      enabled: true
    };
  },

  validationSchema: Yup.object().shape({
    name: Yup.string()
      .required()
      .min(3, 'Minimaal 3 karakters')
      .max(255, 'Maximaal 255 karakters')
  }),

  form: (props) => {
    const submit = props.update ? 'Opslaan' : 'Toevoegen';
    return (
      <Form className="form">
        {props.status && (
          <div className={`alert alert-${props.status.type}`}>{props.status.text}</div>
        )}

        <TextField autoFocus props={props} name="name" title="Naam" />
        <CheckField props={props} name="enabled" title="Actief" />

        <button className="btn btn-primary" disabled={props.isSubmitting || !props.isValid}>
          {submit}
        </button>
        <Link to="/locations/" className="btn btn-secondary float-right">
          Annuleren
        </Link>
      </Form>
    );
  }
});
